import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/member/list/page', data, {
    trim: true
  })
}

export function getById (id) {
  return request.get(`/business/member/detail/${id}`)
}
export function updateStatus (data) {
  return request.post('/business/member/updateStatus', data)
}
export function exportExcel (data) {
  return request.post('/business/member/list/exportExcel', data, {
    download: true,
    trim: true
  })
}
